export const REPORT_TYPE = {
  PERSONAL: "PERSONAL",
  GENERAL: "GENERAL",
};
